import request from '../utils/fetch'
//获取乐园列表
export function getParadiseByStore (data) {
  return request({
    url: '/paradise/getParadiseByStore',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function switchPar (data) {
  return request({
    url: '/paradise/switchPar',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
//新增乐园
export function addParadise (data) {
  return request({
    url: '/paradise/addParadise',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function updateParadise (data) {
  return request({
    url: '/paradise/updateParadise',
    method: 'put',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function deleteParadise (data) {
  return request({
    url: '/paradise/delete',
    method: 'delete',
    requestBody: 'query',
    loading: true,
    params: data
  })
}



